import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export interface WithToastProps {
	children: React.ReactNode
}

export const WithToast = (props: WithToastProps) => {
	const { children } = props;

	return (
		<>
			<ToastContainer theme="light" position={'top-center'} style={{ top: "42px" }} />
			{children}
		</>
	)
}
